let config = window._env_ == null ? process.env : window._env_;
const appSettings = {
  OIDC_PROVIDER: config.OIDC_PROVIDER,
  OIDC_CLIENT_ID: config.OIDC_CLIENT_ID,
  OIDC_REDIRECT_ROUTE: config.OIDC_REDIRECT_ROUTE,
  OIDC_END_SESSION_ENDPOINT: config.OIDC_END_SESSION_ENDPOINT,
  APPINSIGHTS_INSTRUMENTATIONKEY: config.APPINSIGHTS_INSTRUMENTATIONKEY,
  FEATURE_FLAGGING_KEY: config.FEATURE_FLAGGING_KEY,
  API_BASE_URL: config.API_BASE_URL,
  PORTAL_API_BASE_URL: config.PORTAL_API_BASE_URL,
  ASSET_PATH: config.ASSET_PATH,
  environment: config.environment,
  SESSION_DURATION: config.SESSION_DURATION,
  APIM_BASE_URL: config.APIM_BASE_URL,
  CONVERSATION_SERVICE_NAME: config.CONVERSATION_SERVICE_NAME,
  FERRY_FLIGHT_PDF: config.FERRY_FLIGHT_PDF,
  AIRCRAFT_MTX_HISTORY_BASE_URL: config.AIRCRAFT_MTX_HISTORY_BASE_URL,
};
export default appSettings;
